/** @typedef {import('../../types/auth').LoginRequest} LoginRequest */
/** @typedef {import('../../types/auth').LoginResponse} LoginResponse */
/** @typedef {import('../../types/auth').SignupRequest} SignupRequest */
/** @typedef {import('../../types/api').ApiResponse} ApiResponse */

import {
  changePassword as changePasswordAction,
  complete2fa as complete2faAction,
  disable2fa as disable2faAction,
  enable2fa as enable2faAction,
  login as loginAction,
  requestPasswordReset as requestPasswordResetAction,
  resendOTP as resendOTPAction,
  resendVerificationLink as resendVerificationLinkAction,
  signup as signupAction,
  signupV2 as signupV2Action,
  updatePassword as updatePasswordAction,
  verify2faCode as verify2faCodeAction,
  verifyEmail as verifyEmailAction,
  verifyOTP as verifyOTPAction
} from '@basqet-dashboard/common/api';
import { useMutation } from 'react-query';

/** @deprecated Use OIDC flow instead.
 * @returns {import('react-query').UseMutationResult<ApiResponse<LoginResponse>, Error, LoginRequest>} */
export const useLoginMutation = () => {
  return useMutation({
    mutationFn: (loginData) => loginAction(loginData)
  });
};
/** @deprecated Use OIDC flow instead.
 * @returns {import('react-query').UseMutationResult<ApiResponse<Object>, Error, SignupRequest>} */
export const useSignupMutation = () => {
  return useMutation({
    mutationFn: (signupData) => signupAction(signupData)
  });
};
export const useUpdatePasswordMutation = () => {
  return useMutation({
    mutationFn: (updatePasswordData) => updatePasswordAction(updatePasswordData)
  });
};
export const useEnable2faMutation = () => {
  return useMutation({
    mutationFn: (enable2faData) => enable2faAction(enable2faData)
  });
};
export const useComplete2faMutation = () => {
  return useMutation({
    mutationFn: (complete2faData) => complete2faAction(complete2faData)
  });
};
export const useDisable2faMutation = () => {
  return useMutation({
    mutationFn: (disable2faData) => disable2faAction(disable2faData)
  });
};
export const useVerify2faCodeMutation = () => {
  return useMutation({
    mutationFn: (verify2faCodeData) => verify2faCodeAction(verify2faCodeData)
  });
};
export const useVerifyEmailMutation = () => {
  return useMutation({
    mutationFn: (verifyEmailData) => verifyEmailAction(verifyEmailData)
  });
};
export const useResendVerificationLinkMutation = () => {
  return useMutation({
    mutationFn: () => resendVerificationLinkAction()
  });
};
export const useRequestPasswordResetMutation = () => {
  return useMutation({
    mutationFn: (requestPasswordResetData) => requestPasswordResetAction(requestPasswordResetData)
  });
};
export const useChangePasswordMutation = () => {
  return useMutation({
    mutationFn: (changePasswordData) => changePasswordAction(changePasswordData)
  });
};
export const useSignupV2Mutation = () => {
  return useMutation({
    mutationFn: (signupData) => signupV2Action(signupData)
  });
};
export const useVerifyOTPMutation = () => {
  return useMutation({
    mutationFn: (verifyData) => verifyOTPAction(verifyData)
  });
};
export const useResendOTPMutation = () => {
  return useMutation({
    mutationFn: (resendData) => resendOTPAction(resendData)
  });
};
